import axios from 'axios'
import { useState, useContext, forwardRef, useImperativeHandle } from "react"
import { UserContext } from '../../hooks/UserContext';

import { Button, Form, Modal } from "react-bootstrap"
import SelectTopicStatus from "./SelectTopicStatus"
import SelectTopicType from "./SelectTopicType"

const NewTopic = forwardRef(({ selectedCourse, addTopicNode }, ref) => {
  const [show, setShow] = useState(false);
  const { user } = useContext(UserContext);

  // Form data
  const [name, setName] = useState();
  const [position, setPosition] = useState();
  const [duration, setDuration] = useState();
  const [description, setDescription] = useState();
  const [status, setStatus] = useState();
  const [type, setType] = useState();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useImperativeHandle(ref, () => ({
    openModal: () => handleShow(),
  }));

  const createTopic = async () => {
    let url = "/api/topics";
    let data;

    console.log(duration)

    try {
      const response = await axios.post(url, {
        name: name,
        position_id: position ? parseInt(position) : null,
        duration: duration ? parseInt(duration) : 1,
        description: description,
        course_id: parseInt(selectedCourse.id),
        status_id: parseInt(status.value),
        type_id: parseInt(type.value),
      }, {
        headers: { 'Authorization': `Bearer ${user.token}`, 'X-EDITOR': 'nanoms' },
      });
      data = response.data;
    } catch (error) {
      console.error(error);
    }

    setName()
    setDescription()
    setPosition()
    setDuration()
    setStatus()
    setType()
    return data
  }

  const escapeHtml = (text) => text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

  // Every new topic starts with one card carrying the topic name as its heading.
  const createInitialCard = async (topic) => {
    try {
      const response = await axios.post("/api/cards", {
        position_id: 1,
        title: topic.name,
        body: `<h1>${escapeHtml(topic.name)}</h1>`,
        topic_id: topic.id,
      }, {
        headers: { 'Authorization': `Bearer ${user.token}`, 'X-EDITOR': 'nanoms' },
      });
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  const handleSubmit = async e => {
    e.preventDefault();
    setShow(false);
    const result = await createTopic();
    if (!result) return;
    const card = await createInitialCard(result);
    const topicNode = {
      "key": result.id,
      "label": result.name,
      "data": result.name,
      "type": result.type,
      "position_id": result.position_id,
      "children": card ? [{
        "key": `${card.topic_id}-${card.id}`,
        "label": `${card.position_id}. card${card.id}`,
        "data": card.body,
        "position_id": card.position_id,
        "cardId": card.id
      }] : []
    };
    addTopicNode(topicNode);
  }

  const handleStatusChange = (currentStatus) => {
    setStatus(currentStatus);
    console.log(`We changed type and selected status is ${currentStatus.name}`)
    console.log(currentStatus)
  };

  const handleTypeChange = (currentType) => {
    setType(currentType);
    console.log(`We changed type and selected type is ${currentType.name}`)
    console.log(currentType)
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Topic</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="formTopicName">
            <Form.Label>Name: </Form.Label>
            <Form.Control type="text" onChange={e => setName(e.target.value)} value={name} placeholder="" />
          </Form.Group>
          <Form.Group controlId="formTopicDescription">
            <Form.Label>Description: </Form.Label>
            <Form.Control type="text" as='textarea' onChange={e => setDescription(e.target.value)} value={description} placeholder="" />
          </Form.Group>
          <Form.Group controlId="formTopicPosition">
            <Form.Label>Position: </Form.Label>
            <Form.Control type="text" onChange={e => setPosition(e.target.value)} value={position} placeholder="Can be empty or number" />
          </Form.Group>
          <Form.Group controlId="formTopicDuration">
            <Form.Label>Duration: </Form.Label>
            <Form.Control type="text" onChange={e => setDuration(e.target.value)} value={duration} placeholder="Can be empty or number" />
          </Form.Group>
          <Form.Group controlId="formTopicStatus">
            <Form.Label>Status: </Form.Label>
            <SelectTopicStatus
              onStatusSelect={handleStatusChange}
            />
          </Form.Group>
          <Form.Group controlId="formTopicType">
            <Form.Label>Type: </Form.Label>
            <SelectTopicType
              onTypeSelect={handleTypeChange}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Add
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
});

export default NewTopic;